<template>
    <Teleport to="body">
        <div class="modal fade" id="modal_employeesubstitute" role="dialog">
            <div class="modal-dialog modal-lg">
                <form id="employeesubstitutemodalform" method="post">
                    @csrf
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="serviceModalLabel">{{ $trans.get("__JSON__.Enter employee substitution") }}</h5>
                            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <span class="material-symbols-outlined">
                                    close
                                </span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-6 mb-3">
                                    <label for="employee_id" class="form-label">{{ $trans.get("__JSON__.Employee") }}</label>
                                    <select class="form-control" id="employee_id" name="employee_id">
                                        <option value="" selected>{{ $trans.get("__JSON__.Choose employee") }} </option>
                                        <option v-for="employee in employees" value="{{ employee.id }}">
                                            {{ employee.lastname }}, {{ employee.forename }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-6 mb-3">
                                    <label for="substitute_employee_id" class="form-label">{{ $trans.get("__JSON__.Substitute employee") }}</label>
                                    <select class="form-control" id="substitute_employee_id"
                                        name="substitute_employee_id">
                                        <option value="" selected>{{ $trans.get("__JSON__.Choose substitute employee") }} </option>
                                        <option v-for="employee in employees" value="{{ employee.id }}">
                                            {{ employee.lastname }}, {{ employee.forename }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button v-if="actiontype=='create'" type="submit" class="btn btn-primary">{{ $trans.get("__JSON__.Save") }}</button>
                            <button v-if="actiontype=='edit'" type="submit" class="btn btn-primary">{{ $trans.get("__JSON__.Edit") }}</button>
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $trans.get("__JSON__.Close") }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </Teleport>
</template>

<script>

export default {
    setup() {
    },
    name: "EmployeeSubstitutionModal",
    created() {
    },
    props: {
        actiontype: String,
        employees: Object,
        employeesubstitution: Object
    },
    data() {
        return {
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        closeModal() {
            let modal = '#modal_' + this.id;
            $(modal).modal("hide");
        }
    }
};
</script>